import { useMediaQuery, useTheme } from '@mui/material';
import { useToggleAndCloseOnPathChanged } from 'hooks/useToggleAndCloseOnPathChanged';

type HeaderProps = {
    mobileHeader: (isOpen: boolean, toggleDrawer: () => void) => JSX.Element;
    desktopHeader: (isOpen: boolean, toggleDrawer: () => void) => JSX.Element;
    breakpoint?: 'sm' | 'md' | 'lg' | 'xl';
};

export default function Header({ mobileHeader, desktopHeader, breakpoint = 'sm' }: HeaderProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint));

    const [isOpen, toggleDrawer] = useToggleAndCloseOnPathChanged();

    if (isMobile) {
        return mobileHeader(isOpen, toggleDrawer);
    }

    return desktopHeader(isOpen, toggleDrawer);
}
